// Full 78-card tarot deck (bilingual). Images served locally from /public/cards/{card_key}.jpg
const localImg = (key) => `/cards/${key}.jpg`;

const MAJOR_META = [
  { key: "the_fool",           name_en: "The Fool",           name_fr: "Le Mat",             roman: "0"    },
  { key: "the_magician",       name_en: "The Magician",       name_fr: "Le Bateleur",        roman: "I"    },
  { key: "the_high_priestess", name_en: "The High Priestess", name_fr: "La Papesse",         roman: "II"   },
  { key: "the_empress",        name_en: "The Empress",        name_fr: "L'Impératrice",      roman: "III"  },
  { key: "the_emperor",        name_en: "The Emperor",        name_fr: "L'Empereur",         roman: "IV"   },
  { key: "the_hierophant",     name_en: "The Hierophant",     name_fr: "Le Pape",            roman: "V"    },
  { key: "the_lovers",         name_en: "The Lovers",         name_fr: "L'Amoureux",         roman: "VI"   },
  { key: "the_chariot",        name_en: "The Chariot",        name_fr: "Le Chariot",         roman: "VII"  },
  { key: "strength",           name_en: "Strength",           name_fr: "La Force",           roman: "VIII" },
  { key: "the_hermit",         name_en: "The Hermit",         name_fr: "L'Ermite",           roman: "IX"   },
  { key: "wheel_of_fortune",   name_en: "Wheel of Fortune",   name_fr: "La Roue de Fortune", roman: "X"    },
  { key: "justice",            name_en: "Justice",            name_fr: "La Justice",         roman: "XI"   },
  { key: "the_hanged_man",     name_en: "The Hanged Man",     name_fr: "Le Pendu",           roman: "XII"  },
  { key: "death",              name_en: "Death",              name_fr: "La Mort",            roman: "XIII" },
  { key: "temperance",         name_en: "Temperance",         name_fr: "Tempérance",         roman: "XIV"  },
  { key: "the_devil",          name_en: "The Devil",          name_fr: "Le Diable",          roman: "XV"   },
  { key: "the_tower",          name_en: "The Tower",          name_fr: "La Maison Dieu",     roman: "XVI"  },
  { key: "the_star",           name_en: "The Star",           name_fr: "L'Étoile",           roman: "XVII" },
  { key: "the_moon",           name_en: "The Moon",           name_fr: "La Lune",            roman: "XVIII"},
  { key: "the_sun",            name_en: "The Sun",            name_fr: "Le Soleil",          roman: "XIX"  },
  { key: "judgement",          name_en: "Judgement",          name_fr: "Le Jugement",        roman: "XX"   },
  { key: "the_world",          name_en: "The World",          name_fr: "Le Monde",           roman: "XXI"  },
];

const MAJOR = MAJOR_META.map((m, i) => ({
  id: i,
  arcana: "major",
  ...m,
  image: localImg(m.key),
}));

const SUITS = [
  { key: "cups",      name_en: "Cups",      name_fr: "Coupes",  glyph: "♥" },
  { key: "wands",     name_en: "Wands",     name_fr: "Bâtons",  glyph: "♣" },
  { key: "swords",    name_en: "Swords",    name_fr: "Épées",   glyph: "♠" },
  { key: "pentacles", name_en: "Pentacles", name_fr: "Deniers", glyph: "★" },
];

const RANKS = [
  { key: "ace",    name_en: "Ace",    name_fr: "As",       roman: "I"    },
  { key: "two",    name_en: "Two",    name_fr: "Deux",     roman: "II"   },
  { key: "three",  name_en: "Three",  name_fr: "Trois",    roman: "III"  },
  { key: "four",   name_en: "Four",   name_fr: "Quatre",   roman: "IV"   },
  { key: "five",   name_en: "Five",   name_fr: "Cinq",     roman: "V"    },
  { key: "six",    name_en: "Six",    name_fr: "Six",      roman: "VI"   },
  { key: "seven",  name_en: "Seven",  name_fr: "Sept",     roman: "VII"  },
  { key: "eight",  name_en: "Eight",  name_fr: "Huit",     roman: "VIII" },
  { key: "nine",   name_en: "Nine",   name_fr: "Neuf",     roman: "IX"   },
  { key: "ten",    name_en: "Ten",    name_fr: "Dix",      roman: "X"    },
  { key: "page",   name_en: "Page",   name_fr: "Valet",    roman: "V."   },
  { key: "knight", name_en: "Knight", name_fr: "Cavalier", roman: "Cv."  },
  { key: "queen",  name_en: "Queen",  name_fr: "Reine",    roman: "R."   },
  { key: "king",   name_en: "King",   name_fr: "Roi",      roman: "Ro."  },
];

const buildMinor = () => {
  const out = [];
  let id = 22;
  for (const s of SUITS) {
    for (const r of RANKS) {
      const key = `${r.key}_of_${s.key}`;
      out.push({
        id: id++,
        key,
        name_en: `${r.name_en} of ${s.name_en}`,
        name_fr: `${r.name_fr} de ${s.name_fr}`,
        arcana: "minor",
        suit: s.key,
        suit_glyph: s.glyph,
        rank: r.key,
        roman: r.roman,
        image: localImg(key),
      });
    }
  }
  return out;
};

export const MINOR_ARCANA = buildMinor();
export const FULL_DECK = [...MAJOR, ...MINOR_ARCANA];

export const CARD_BY_KEY = FULL_DECK.reduce((acc, c) => {
  acc[c.key] = c;
  return acc;
}, {});

export const shuffleDeck = (deck) => {
  const arr = deck.slice();
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
};

export const nameForLang = (card, lang) => (lang === "fr" ? card.name_fr : card.name_en);
